import React, { Dispatch, SetStateAction } from "react";
import PropTypes from "prop-types";
import { InputGroup, FormControl } from "react-bootstrap";
import { useFormContext, get } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage } from "react-intl";
import "./input.scss";

interface InputProps {
  placeholder?: string;
  mode?: "basic" | "search" | "form";
  errorMsg?: string;
  name?: string | undefined;
  borderless?: boolean;
  type?: string;
  required?: boolean;
  validations?: object;
  setShowRecent?: SetStateAction<Dispatch<boolean>>;
  disabled?: boolean;
  defaultValue?: any;
  min?: number;
  eventContext?: string;
  eventName?: string;
  className?: string;
  as?: string;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
}

const Input = function ({
  mode,
  placeholder,
  type,
  borderless,
  errorMsg,
  name,
  as,
  required,
  validations,
  setShowRecent,
  eventContext: _eventContext,
  eventName: _eventName,
  className,
  ...props
}: InputProps) {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const { onBlur: onBlurProp, ...inputProps } = props;
  const registration = name ? register(name, { required, ...validations }) : null;

  return (
    <>
      <InputGroup className="w-100 br-5 d-flex flex-column">
        {mode === "search" ? (
          <InputGroup.Prepend>
            <InputGroup.Text>
              <FontAwesomeIcon icon={faSearch} />
            </InputGroup.Text>
          </InputGroup.Prepend>
        ) : null}

        {name && registration && (
          <FormControl
            className={`${required && get(errors, name) ? "border-danger" : "form-control"} ${className}`}
            type={type}
            placeholder={placeholder}
            {...registration}
            {...inputProps}
            onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
              registration.onBlur(event);
              onBlurProp?.(event);
            }}
          />
        )}
      </InputGroup>
      {required && name
        ? get(errors, name) && (
            <div className="d-block font-b3 invalid-feedback">
              {get(errors, name)?.message ? (
                get(errors, name).message
              ) : (
                <FormattedMessage id="general.requiredField" defaultMessage="This is a required field" />
              )}
            </div>
          )
        : null}
    </>
  );
};

Input.propTypes = {
  placeholder: PropTypes.string,
  mode: PropTypes.oneOf(["basic", "search", "form"]),
  errorMsg: PropTypes.string,
  name: PropTypes.string,
  borderless: PropTypes.bool,
  type: PropTypes.string,
  required: PropTypes.bool,
  validations: PropTypes.instanceOf(Object),
  setShowRecent: PropTypes.func,
  eventContext: PropTypes.string,
  eventName: PropTypes.string,
  className: PropTypes.string,
};

Input.defaultProps = {
  as: "",
  placeholder: "",
  mode: "basic",
  errorMsg: "Please enter a value",
  name: "email",
  borderless: false,
  type: "text",
  required: false,
  validations: null,
  eventName: "",
  setShowRecent: () => {},
  disabled: false,
  defaultValue: null,
  min: null,
  eventContext: undefined,
  className: "",
};

export default Input;
